"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _account = _interopRequireDefault(require("./icons/account.svg"));

var _alertCircle = _interopRequireDefault(require("./icons/alert-circle.svg"));

var _arrowLeft = _interopRequireDefault(require("./icons/arrow-left.svg"));

var _arrowUpDown = _interopRequireDefault(require("./icons/arrow-up-down.svg"));

var _cancel = _interopRequireDefault(require("./icons/cancel.svg"));

var _check = _interopRequireDefault(require("./icons/check.svg"));

var _chevronDown = _interopRequireDefault(require("./icons/chevron-down.svg"));

var _chevronLeft = _interopRequireDefault(require("./icons/chevron-left.svg"));

var _chevronRight = _interopRequireDefault(require("./icons/chevron-right.svg"));

var _chevronUp = _interopRequireDefault(require("./icons/chevron-up.svg"));

var _close = _interopRequireDefault(require("./icons/close.svg"));

var _cursorMove = _interopRequireDefault(require("./icons/cursor-move.svg"));

var _delete = _interopRequireDefault(require("./icons/delete.svg"));

var _dotsVertical = _interopRequireDefault(require("./icons/dots-vertical.svg"));

var _eyeOff = _interopRequireDefault(require("./icons/eye-off.svg"));

var _eye = _interopRequireDefault(require("./icons/eye.svg"));

var _fullscreen = _interopRequireDefault(require("./icons/fullscreen.svg"));

var _home = _interopRequireDefault(require("./icons/home.svg"));

var _lockOpen = _interopRequireDefault(require("./icons/lock-open.svg"));

var _lock = _interopRequireDefault(require("./icons/lock.svg"));

var _magnify = _interopRequireDefault(require("./icons/magnify.svg"));

var _menu = _interopRequireDefault(require("./icons/menu.svg"));

var _nfc = _interopRequireDefault(require("./icons/nfc.svg"));

var _pencil = _interopRequireDefault(require("./icons/pencil.svg"));

var _plus = _interopRequireDefault(require("./icons/plus.svg"));

var _power = _interopRequireDefault(require("./icons/power.svg"));

var _reload = _interopRequireDefault(require("./icons/reload.svg"));

var _selectAll = _interopRequireDefault(require("./icons/select-all.svg"));

var _settings = _interopRequireDefault(require("./icons/settings.svg"));

var _shapeRectanglePlus = _interopRequireDefault(require("./icons/shape-rectangle-plus.svg"));

var _star = _interopRequireDefault(require("./icons/star.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const icons = {
  alertCircle: _alertCircle.default,
  account: _account.default,
  arrowLeft: _arrowLeft.default,
  arrowUpDown: _arrowUpDown.default,
  cancel: _cancel.default,
  check: _check.default,
  chevronDown: _chevronDown.default,
  chevronLeft: _chevronLeft.default,
  chevronRight: _chevronRight.default,
  chevronUp: _chevronUp.default,
  close: _close.default,
  cursorMove: _cursorMove.default,
  dotsVertical: _dotsVertical.default,
  eye: _eye.default,
  eyeOff: _eyeOff.default,
  fullscreen: _fullscreen.default,
  home: _home.default,
  lock: _lock.default,
  lockOpen: _lockOpen.default,
  magnify: _magnify.default,
  menu: _menu.default,
  nfc: _nfc.default,
  pencil: _pencil.default,
  plus: _plus.default,
  power: _power.default,
  reload: _reload.default,
  remove: _delete.default,
  selectAll: _selectAll.default,
  settings: _settings.default,
  shapeRectanglePlus: _shapeRectanglePlus.default,
  star: _star.default
};

const disableClick = (onClick, disabled) => e => {
  if (disabled) {
    return;
  }

  if (onClick) {
    onClick(e);
  }
};

const SVGIcon = /*#__PURE__*/(0, _react.forwardRef)(({
  className,
  name,
  title,
  onClick,
  disabled
}, ref) => /*#__PURE__*/_react.default.createElement("div", {
  className: className,
  title: title,
  dangerouslySetInnerHTML: {
    __html: icons[name]
  },
  onClick: disableClick(onClick, disabled),
  disabled: disabled,
  ref: ref
}));

var _default = (0, _styledComponents.default)(SVGIcon).withConfig({
  displayName: "SVGIcon",
  componentId: "ceaq45-0"
})([" ", ""], p => (0, _styledComponents.css)(["display:flex;justify-content:center;align-items:center;flex-shrink:0;width:32px;height:32px;cursor:pointer;", ";", ";", ";&:hover{", ";", ";}svg{width:100%;padding:4px;path{", ";fill:", ";}}"], p.background && (0, _styledComponents.css)(["background:", ";"], p.background), p.theme.transition, p.name === 'sortAsc' && (0, _styledComponents.css)(["transform:scale(1,-1);"]), p.hoverBackground && (0, _styledComponents.css)(["background:", ";"], p.hoverBackground), p.hoverColor && (0, _styledComponents.css)(["svg path{fill:", ";}"], p.hoverColor), p => p.theme.transition, p => p.color ? p.color : '#555'));

exports.default = _default;